<template>
  <v-container fluid class="grey darken-4 ld-container">
    <v-layout row class="ld-layout">
      <!-- Navigation -->
      <v-flex class="ld-navigation">
        <navigation-main-component
          @onClickNav1="onClickNav1"
          @onClickNav2="onClickNav2"
          @onClickNav3="onClickNav3"
          @onClickNav4="onClickNav4"
          @onClickNav5="onClickNav5"
        ></navigation-main-component>
      </v-flex>
      <div v-show="!screenWidthSmall" class="ld-left-slide-container">
        <div class="ld-logo">
          <!-- Logo -->
          <img :src="getComponentImagePath('lollicup_logo_transparency_400_201.png')"/>
        </div>
        <div class="ld-left-slide-carousel">
          <!-- 'setStyleImage' needs to be an object (i.e. - "{transform: 'translate(\'-33em\')}") -->
          <nav-slide-component
            @imageMounted="imageMountedLollicupOpenNight"
            :setClassContainer="'ld-left-slide ld-scroll-none'"
            :setClassImage="'ld-left-slide-image'"
            :setIdImage="imageIdOpenNight"
            :setSourceImage="getComponentImagePath('lollicup_open_night_1800_1200.jpg')"
            :setStyleContainer="''"
            :setStyleImage="setImageStyleOpenNight"
            :style="{
              'bottom': '400%',
              'overflow': 'hidden',
              'transform': leftSlide1Translate,
              'transition': slideTransformDuration
            }"
          ></nav-slide-component>
          <!-- Cheers -->
          <!-- 'setStyleImage' needs to be an object (i.e. - "{transform: 'translate(\'-33em\')}") -->
          <nav-slide-component
            @imageMounted="imageMountedLollicupCheers"
            :setClassContainer="'ld-left-slide ld-scroll-none'"
            :setClassImage="'ld-left-slide-image'"
            :setIdImage="imageIdCheers"
            :setSourceImage="getComponentImagePath('lollicup_cheers_1200_1200.JPG')"
            :setStyleContainer="''"
            :setStyleImage="setImageStyleCheers"
            :style="{
              'bottom': '400%',
              'overflow': 'hidden',
              'transform': leftSlide2Translate,
              'transition': slideTransformDuration
            }"
          ></nav-slide-component>
          <!-- Snacks -->
          <!-- 'setStyleImage' needs to be an object (i.e. - "{transform: 'translate(\'-33em\')}") -->
          <nav-slide-component
            @imageMounted="imageMountedLollicupSnacks"
            :setClassContainer="'ld-left-slide ld-scroll-none'"
            :setClassImage="'ld-left-slide-image'"
            :setIdImage="imageIdSnacks"
            :setSourceImage="getComponentImagePath('lollicup_food_snacks_1812_1200.jpg')"
            :setStyleContainer="''"
            :setStyleImage="setImageStyleSnacks"
            :style="{
              'bottom': '400%',
              'overflow': 'hidden',
              'transform': leftSlide3Translate,
              'transition': slideTransformDuration
            }"
          ></nav-slide-component>
          <!-- Books -->
          <!-- 'setStyleImage' needs to be an object (i.e. - "{transform: 'translate(\'-33em\')}") -->
          <nav-slide-component
            @imageMounted="imageMountedLollicupBooks"
            :setClassContainer="'ld-left-slide ld-scroll-none'"
            :setClassImage="'ld-left-slide-image'"
            :setIdImage="imageIdBooks"
            :setSourceImage="getComponentImagePath('lollicup_entertainment_books_1812_1200.jpg')"
            :setStyleContainer="''"
            :setStyleImage="setImageStyleBooks"
            :style="{
              'bottom': '400%',
              'overflow': 'hidden',
              'transform': leftSlide4Translate,
              'transition': slideTransformDuration
            }"
          ></nav-slide-component>
          <!-- Steamed Buns -->
          <!-- 'setStyleImage' needs to be an object (i.e. - "{transform: 'translate(\'-33em\')}") -->
          <nav-slide-component
            @imageMounted="imageMountedLollicupSteamedBuns"
            :setClassContainer="'ld-left-slide ld-scroll-none'"
            :setClassImage="'ld-left-slide-image'"
            :setIdImage="imageIdSteamedBuns"
            :setSourceImage="getComponentImagePath('lollicup_store_front_decal_1200_1200.jpg')"
            :setStyleContainer="''"
            :setStyleImage="setImageStyleSteamedBuns"
            :style="{
              'bottom': '400%',
              'overflow': 'hidden',
              'transform': leftSlide5Translate,
              'transition': slideTransformDuration
            }"
          ></nav-slide-component>
        </div>
      </div>
      <v-flex class="ld-right-slide-container" :class="{ 'ld-right-slide-width-half' : !screenWidthSmall,
      'ld-right-slide-width-full' : screenWidthSmall}">
        <div class="ld-right-slide-carousel">
          <!-- Home image -->
          <home-component
            :screenWidthSmall="screenWidthSmall"
            :style="{bottom: '0', transition: slideTransformDuration, transform: rightSlide1Translate}"
            :windowHeight="windowHeight"
            :windowWidth="windowWidth"
          ></home-component>
          <!-- About -->
          <about-component
            :screenWidthSmall="screenWidthSmall"
            :style="{bottom: '-100%', transition: slideTransformDuration, transform: rightSlide2Translate}"
          ></about-component>
          <!-- Menu -->
          <menu-component
            :screenWidthSmall="screenWidthSmall"
            :style="{bottom: '-200%', transition: slideTransformDuration, transform: rightSlide3Translate}"
          ></menu-component>
          <!-- Gallery -->
          <gallery-component
            :screenWidthSmall="screenWidthSmall"
            :style="{bottom: '-300%', transition: slideTransformDuration, transform: rightSlide4Translate}"
          ></gallery-component>
          <!-- Contact -->
          <contact-component
            :screenWidthSmall="screenWidthSmall"
            :style="{bottom: '-400%', transition: slideTransformDuration, transform: rightSlide5Translate}"
          ></contact-component>
        </div>
      </v-flex>
      <modal-landing-popup v-if="showModalLandingPopup"></modal-landing-popup>
    </v-layout>
  </v-container>
</template>

<script>
  import * as Utils from '../js/utils';
  import AboutComponent from './about_component.vue';
  import ContactComponent from './contact_component.vue';
  import GalleryComponent from './gallery_component.vue';
  import GeneralMixin from '../mixins/general_mixin';
  import HomeComponent from './home_component.vue';
  import MenuComponent from './menu_component.vue';
  import ModalLandingPopup from './modal_landing_popup.vue';
  import NavSlideComponent from './nav_slide_component.vue';
  import NavigationMainComponent from './navigation_main_component.vue';

  export default {
    components: {
      AboutComponent,
      ContactComponent,
      GalleryComponent,
      HomeComponent,
      MenuComponent,
      ModalLandingPopup,
      NavSlideComponent,
      NavigationMainComponent
    },

    methods: {
      /**
       * getWindowHeight will get the browser view window height.
       */
      getWindowHeight: function() {
        this.windowHeight = Utils.getWindowHeight(document);
      },

      /**
       * getWindowWidth will get the browser view window width.
       */
      getWindowWidth: function() {
        this.windowWidth = Utils.getWindowWidth(document);
      },

      /**
       * imageMountedLollicupBooks will listen for the image mounted event from the nav slide component, then get and
       * set the image style left offset for the Lollicup books image. This functionality was created because the width
       * of the image may not be available on any of the built in Vue instance functions, due to loading delays.
       */
      imageMountedLollicupBooks: function() {
        this.setImageStyleBooks.left = Utils.getImageStyleLeft(document, true, this.imageIdBooks,
          this.screenWidthSmall, this.windowWidth);
      },

      /**
       * imageMountedLollicupCheers will listen for the image mounted event from the nav slide component, then get and
       * set the image style left offset for the Lollicup cheers image. This functionality was created because the
       * width of the image may not be available on any of the built in Vue instance functions, due to loading delays.
       */
      imageMountedLollicupCheers: function() {
        this.setImageStyleCheers.left = Utils.getImageStyleLeft(document, true, this.imageIdCheers,
          this.screenWidthSmall, this.windowWidth);
      },

      /**
       * imageMountedLollicupOpenNight will listen for the image mounted event from the nav slide component, then get
       * and set the image style left offset for the Lollicup open night image. This functionality was created because
       * the width of the image may not be available on any of the built in Vue instance functions, due to loading
       * delays.
       */
      imageMountedLollicupOpenNight: function() {
        this.setImageStyleOpenNight.left = Utils.getImageStyleLeft(document, true, this.imageIdOpenNight,
          this.screenWidthSmall, this.windowWidth);
      },

      /**
       * imageMountedLollicupSnacks will listen for the image mounted event from the nav slide component, then get and
       * set the image style left offset for the Lollicup snacks image. This functionality was created because the
       * width of the image may not be available on any of the built in Vue instance functions, due to loading delays.
       */
      imageMountedLollicupSnacks: function() {
        this.setImageStyleSnacks.left = Utils.getImageStyleLeft(document, true, this.imageIdSnacks,
          this.screenWidthSmall, this.windowWidth);
      },

      /**
       * imageMountedLollicupSteamedBuns will listen for the image mounted event from the nav slide component, then get
       * and set the image style left offset for the Lollicup steamed buns image. This functionality was created
       * because the width of the image may not be available on any of the built in Vue instance functions, due to
       * loading delays.
       */
      imageMountedLollicupSteamedBuns: function() {
        this.setImageStyleSteamedBuns.left = Utils.getImageStyleLeft(document, true, this.imageIdSteamedBuns,
          this.screenWidthSmall, this.windowWidth);
      },

      /**
       * onClickNav1 will listen for the click event of the first navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav1: function() {
        this.transitionSlides(1);
      },

      /**
       * onClickNav2 will listen for the click event of the second navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav2: function() {
        this.transitionSlides(2);
      },

      /**
       * onClickNav3 will listen for the click event of the third navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav3: function() {
        this.transitionSlides(3);
      },

      /**
       * onClickNav4 will listen for the click event of the fourth navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav4: function() {
        this.transitionSlides(4);
      },

      /**
       * onClickNav5 will listen for the click event of the fifth navigation button, then call the
       * 'transitionSlides' to transition the left and right slides.
       */
      onClickNav5: function() {
        this.transitionSlides(5);
      },

      /**
       * transitionSlides will set the slide transition values appropriately, determined by the argument provided.
       * @param navDestination - integer - the navigation button clicked.
       */
      transitionSlides: function(navDestination) {
        switch (navDestination) {
          case 1:
            this.leftSlide1Translate = 'translate(0, 0)';
            this.leftSlide2Translate = 'translate(0, 0)';
            this.leftSlide3Translate = 'translate(0, 0)';
            this.leftSlide4Translate = 'translate(0, 0)';
            this.leftSlide5Translate = 'translate(0, 0)';

            this.rightSlide1Translate = 'translate(0, 0)';
            this.rightSlide2Translate = 'translate(0, 0)';
            this.rightSlide3Translate = 'translate(0, 0)';
            this.rightSlide4Translate = 'translate(0, 0)';
            this.rightSlide5Translate = 'translate(0, 0)';
            break;

          case 2:
            this.leftSlide1Translate = 'translate(0, 100%)';
            this.leftSlide2Translate = 'translate(0, 100%)';
            this.leftSlide3Translate = 'translate(0, 100%)';
            this.leftSlide4Translate = 'translate(0, 100%)';
            this.leftSlide5Translate = 'translate(0, 100%)';

            this.rightSlide1Translate = 'translate(0, -100%)';
            this.rightSlide2Translate = 'translate(0, -100%)';
            this.rightSlide3Translate = 'translate(0, -100%)';
            this.rightSlide4Translate = 'translate(0, -100%)';
            this.rightSlide5Translate = 'translate(0, -100%)';
            break;

          case 3:
            this.leftSlide1Translate = 'translate(0, 200%)';
            this.leftSlide2Translate = 'translate(0, 200%)';
            this.leftSlide3Translate = 'translate(0, 200%)';
            this.leftSlide4Translate = 'translate(0, 200%)';
            this.leftSlide5Translate = 'translate(0, 200%)';

            this.rightSlide1Translate = 'translate(0, -200%)';
            this.rightSlide2Translate = 'translate(0, -200%)';
            this.rightSlide3Translate = 'translate(0, -200%)';
            this.rightSlide4Translate = 'translate(0, -200%)';
            this.rightSlide5Translate = 'translate(0, -200%)';
            break;

          case 4:
            this.leftSlide1Translate = 'translate(0, 300%)';
            this.leftSlide2Translate = 'translate(0, 300%)';
            this.leftSlide3Translate = 'translate(0, 300%)';
            this.leftSlide4Translate = 'translate(0, 300%)';
            this.leftSlide5Translate = 'translate(0, 300%)';

            this.rightSlide1Translate = 'translate(0, -300%)';
            this.rightSlide2Translate = 'translate(0, -300%)';
            this.rightSlide3Translate = 'translate(0, -300%)';
            this.rightSlide4Translate = 'translate(0, -300%)';
            this.rightSlide5Translate = 'translate(0, -300%)';
            break;

          case 5:
            this.leftSlide1Translate = 'translate(0, 400%)';
            this.leftSlide2Translate = 'translate(0, 400%)';
            this.leftSlide3Translate = 'translate(0, 400%)';
            this.leftSlide4Translate = 'translate(0, 400%)';
            this.leftSlide5Translate = 'translate(0, 400%)';

            this.rightSlide1Translate = 'translate(0, -400%)';
            this.rightSlide2Translate = 'translate(0, -400%)';
            this.rightSlide3Translate = 'translate(0, -400%)';
            this.rightSlide4Translate = 'translate(0, -400%)';
            this.rightSlide5Translate = 'translate(0, -400%)';
            break;

          default:
            this.leftSlide1Translate = 'translate(0, 0)';
            this.leftSlide2Translate = 'translate(0, 0)';
            this.leftSlide3Translate = 'translate(0, 0)';
            this.leftSlide4Translate = 'translate(0, 0)';
            this.leftSlide5Translate = 'translate(0, 0)';

            this.rightSlide1Translate = 'translate(0, 0)';
            this.rightSlide2Translate = 'translate(0, 0)';
            this.rightSlide3Translate = 'translate(0, 0)';
            this.rightSlide4Translate = 'translate(0, 0)';
            this.rightSlide5Translate = 'translate(0, 0)';
            break;
        }
      }
    },

    mixins: [GeneralMixin],

    name: 'bodyContainerComponent',

    watch: {
      windowWidth: function(windowWidth) {
        /* Get the mobile browser window width ratio to calculate the screen width  */
        const ratio = window.devicePixelRatio || 1;
        const screenWidth = windowWidth / ratio;
        this.screenWidthSmall = (screenWidth <= 850);

        this.setImageStyleBooks.left = Utils.getImageStyleLeft(document, true, this.imageIdBooks,
          this.screenWidthSmall, windowWidth);

        this.setImageStyleCheers.left = Utils.getImageStyleLeft(document, true, this.imageIdCheers,
          this.screenWidthSmall, windowWidth);

        this.setImageStyleOpenNight.left = Utils.getImageStyleLeft(document, true, this.imageIdOpenNight,
          this.screenWidthSmall, windowWidth);

        this.setImageStyleSnacks.left = Utils.getImageStyleLeft(document, true, this.imageIdSnacks,
          this.screenWidthSmall, windowWidth);

        this.setImageStyleSteamedBuns.left = Utils.getImageStyleLeft(document, true, this.imageIdSteamedBuns,
          this.screenWidthSmall, windowWidth);
      }
    },

    created() {
      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);
      });
    },

    data() {
      return {
        imageIdOpenNight: 'lollicup_open_night_1800_1200',
        imageIdCheers: 'lollicup_cheers_1810_1200',
        imageIdSnacks: 'lollicup_food_snacks_2619_1200',
        imageIdBooks: 'lollicup_entertainment_books_1200_1200',
        imageIdSteamedBuns: 'lollicup_food_steamed_buns_1810_1200',
        // Left slide initial configurations
        leftSlide1Translate: 'translate(0, 0)',
        leftSlide2Translate: 'translate(0, 0)',
        leftSlide3Translate: 'translate(0, 0)',
        leftSlide4Translate: 'translate(0, 0)',
        leftSlide5Translate: 'translate(0, 0)',
        // Right slide initial configurations
        rightSlide1Translate: 'translate(0, 0)',
        rightSlide2Translate: 'translate(0, 0)',
        rightSlide3Translate: 'translate(0, 0)',
        rightSlide4Translate: 'translate(0, 0)',
        rightSlide5Translate: 'translate(0, 0)',
        // Screen width size booleans
        screenWidthSmall: false,
        // Slider Image Component Styles
        setImageStyleBooks: {
          left: 0
        },
        setImageStyleCheers: {
          left: 0
        },
        setImageStyleOpenNight: {
          left: 0
        },
        setImageStyleSnacks: {
          left: 0
        },
        setImageStyleSteamedBuns: {
          left: 0
        },
        showModalLandingPopup: false,
        // Transform configurations
        slideTransformDuration: 'transform 1.5s',
        // Window dimensions
        windowHeight: 0,
        windowWidth: 0
      };
    },

    mounted() {
      this.getWindowWidth();
      this.getWindowHeight();
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/body_container_component.vue